// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".large-text-section[data-v-bbd8c96e]{background-color:var(--c-bg-color);padding-bottom:3rem;padding-top:3rem;box-shadow:0 0 3px 1px rgba(0,0,0,.1)}.large-text-section .grid[data-v-bbd8c96e]{max-width:700px}.large-text-section__text.large-text-section__text[data-v-bbd8c96e]{color:var(--c-text-color);font-size:1.5rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
